module.exports = __webpack_public_path__ + "static/img/handrail.d955cf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/handrail.png
// module id = /Lrf
// module chunks = 1